import globalMethods from "@/globalMethods";
import {URLS} from "@/constants";
import {notify} from "@/plugins/notification";
import i18n from "@/i18n";


export default {
    namespaced: true,
    state: {
        // cache: staffId -> [{id, good, good_name, duration_minutes}]
        byStaffId: {},
        isLoading: false,
    },
    mutations: {
        setStaffServices(state, {staffId, items}) {
            state.byStaffId = {...state.byStaffId, [staffId]: items};
        },
        setLoading(state, value) {
            state.isLoading = value;
        },
    },
    actions: {
        async getStaffServices({commit, rootState}, {staffId}) {
            const {personalData, company} = rootState;
            const url = `${URLS.MODEL.STAFF_SERVICE.STAFF_SERVICES_URL}?staff=${staffId}`;
            const options = {
                method: "GET",
                headers: {
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
                credentials: "include",
            };
            commit("setLoading", true);
            const successfulHandler = (data) => {
                commit("setStaffServices", {staffId: staffId, items: data.data});
                return {successfully: true, data: data.data};
            };
            const result = await globalMethods.sendRequestToGetJson({url, options, successfulHandler});
            commit("setLoading", false);
            return result;
        },
        async updateStaffServices({commit, rootState}, {staffId, items}) {
            const {personalData, company} = rootState;
            const url = URLS.MODEL.STAFF_SERVICE.STAFF_SERVICES_URL;
            const options = {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
                body: JSON.stringify({staff: staffId, items: items}),
                credentials: "include",
            };
            const successfulHandler = (data) => {
                commit("setStaffServices", {staffId: staffId, items: data.data});
                notify(i18n.global.t("Staff services updated"), "black", 3000);
                return {successfully: true, data: data.data};
            };
            return globalMethods.sendRequestToGetJson({url, options, successfulHandler});
        },
    },
    getters: {
        getByStaffId: (state) => (staffId) => state.byStaffId[staffId] || null,
    },
};
